import {AManagerApi} from "@/classes/app/api/manager/a-manager-api";

export default class ShopMenuCategory extends AManagerApi {
    protected _url: string = '/owner/site/shop/menu/category';
}
